import {useEffect, useRef, useState} from 'react';

import {batch, useDispatch} from 'react-redux';

import {showLoading, updateLoading} from '@/actions/loadingActions';
import {showAlert} from '@/actions/setupActions';
import {GetRequest} from '@/api/request';
import {GET_USB_DRIVE} from '@/constants/apis';
import {USB_FLASH} from '@/constants/configurations';
import {ALERT_TYPE} from '@/constants/enums';
import {CLOSE} from '@/constants/pcConstAppData';

import useIntlFormat from './useIntlFormat';

const useUsb = () => {
  const hookRef = useRef(null);
  const [usbList, setUsbList] = useState([]);
  const dispatch = useDispatch();
  const {formatMessage} = useIntlFormat();

  useEffect(
    () => () => {
      clearUsbListInterval();
    },
    [],
  );

  const refreshUsbList = () => {
    dispatch(
      updateLoading({
        showLoading: true,
        loadingText: formatMessage({id: 'loading.usb.checking.message'}),
        loadingClickEvent: () => {},
        loadingButton1: {
          label: CLOSE,
          onClick: () => {
            clearUsbListInterval();
            dispatch(showLoading(false));
          },
        },
      }),
    );
    registerUsbListInterval();
    setTimeout(
      () =>
        batch(() => {
          if (hookRef.current === null) return;

          clearUsbListInterval();
          dispatch(showLoading(false));
          dispatch(
            showAlert({
              alertShow: true,
              alertText: formatMessage({id: 'toast.usb.usbNotFound.message'}),
              alertStyle: ALERT_TYPE.ALERT_DANGER,
            }),
          );
        }),
      15000,
    );
  };

  const registerUsbListInterval = () => {
    clearUsbListInterval();
    hookRef.current = setInterval(() => {
      const params = {
        params: {
          partition: USB_FLASH.PARTITION_USB_FLASH,
        },
      };
      GetRequest(GET_USB_DRIVE, params)
        .then((response) => {
          const {details} = response.data;
          if (details.length > 0) {
            clearUsbListInterval();
            // remove /rootfs and /boot partitions
            // eslint-disable-next-line prefer-regex-literals
            const regex = new RegExp('(rootfs|boot)(-[0-9]+)?$');
            const filteredDetails = details.filter(({Path}) => !regex.test(Path));
            setUsbList(filteredDetails);
            dispatch(showLoading(false));
          }
        })
        .catch(() => {
          clearUsbListInterval();
          batch(() => {
            dispatch(showLoading(false));
            dispatch(
              showAlert({
                alertShow: true,
                alertText: formatMessage({id: 'toast.usb.failedGetInfo.message'}),
                alertStyle: ALERT_TYPE.ALERT_DANGER,
              }),
            );
          });
        });
    }, 1000);
  };

  const clearUsbListInterval = () => {
    if (hookRef.current) {
      clearInterval(hookRef.current);
      hookRef.current = null;
    }
  };

  return {usbList, RefreshUsbList: refreshUsbList};
};
export default useUsb;
